import React from 'react';
import PropTypes from 'prop-types';
import { Button, Icon } from 'semantic-ui-react';
import { colorsModeUI } from '../modeUI';
import { SIZE_MEDIUM } from '../constants';

import './index.css';

export const TYPE_FILE = 'TYPE_FILE';

/**
 * Ui Button
 * Display the semantic component Buttons according the selected design
 * Props (parameters)
 * @param string id
 * @param bool showLabels
 * @param string sizeButton
 * @param bool disabled
 * @param string label
 * @param func onClick
 * @param bool primary
 * @param string iconName
 * @param bool negative
 * @param bool fluid
 * @param bool basic: without border and background
 *  by hover only the color of the icon/label will be changed
 * @param string mode
 */
export default class UiButton extends React.PureComponent {
  constructor(props) {
    super(props);
    this.toggleHover = this.toggleHover.bind(this);
    this.styleButtonBasic = this.styleButtonBasic.bind(this);
    this.styleButton = this.styleButton.bind(this);
    this.state = {
      hover: false,
    };
  }

  /**
   * Toggle hover
   */
  toggleHover() {
    const { hover } = this.state;
    this.setState({ hover: !hover });
  }

  /**
   * Style button basic
   * this function defines the style by a basic button, without border and background
   * by hover only the color of the icon/label will be changed
   */
  styleButtonBasic() {
    const { mode, disabled, primary } = this.props;
    const { hover } = this.state;
    const style = { display: 'initial' };
    if (mode !== null) {
      const modeColors = colorsModeUI(mode);
      if (disabled) {
        style.color = modeColors.ICON_COLOR;
      } else if (primary) {
        style.color = hover
          ? modeColors.ICON_PRIMARY_HOVER_COLOR
          : modeColors.ICON_PRIMARY_COLOR;
      } else {
        style.color = hover
          ? modeColors.ICON_COLOR_HIGHLIGHT
          : modeColors.ICON_COLOR;
      }
    }
    return style;
  }

  /**
   * Style button
   * this function defined the style by a standard button, with a background
   */
  styleButton() {
    const { mode, disabled, primary, negative } = this.props;
    const { hover } = this.state;
    const style = {};
    if (mode !== null) {
      const modeColors = colorsModeUI(mode);
      if (disabled) {
        style.backgroundColor = primary
          ? modeColors.BUTTON_PRIMARY_DISABLED_BACKGROUND_COLOR
          : modeColors.BUTTON_DISABLED_BACKGROUND_COLOR;
        style.color = primary
          ? modeColors.BUTTON_PRIMARY_DISABLED_COLOR
          : modeColors.BUTTON_DISABLED_COLOR;
      } else if (negative) {
        style.backgroundColor = hover
          ? modeColors.BUTTON_NEGATIVE_HOVER_BACKGROUND_COLOR
          : modeColors.BUTTON_NEGATIVE_BACKGROUND_COLOR;
        style.color = hover
          ? modeColors.BUTTON_NEGATIVE_HOVER_COLOR
          : modeColors.BUTTON_NEGATIVE_COLOR;
      } else if (primary) {
        style.backgroundColor = hover
          ? modeColors.BUTTON_PRIMARY_HOVER_BACKGROUND_COLOR
          : modeColors.BUTTON_PRIMARY_BACKGROUND_COLOR;
        style.color = hover
          ? modeColors.BUTTON_PRIMARY_HOVER_COLOR
          : modeColors.BUTTON_PRIMARY_COLOR;
      } else {
        style.backgroundColor = hover
          ? modeColors.BUTTON_HOVER_BACKGROUND_COLOR
          : modeColors.BUTTON_BACKGROUND_COLOR;
        style.color = hover
          ? modeColors.BUTTON_HOVER_COLOR
          : modeColors.BUTTON_COLOR;
      }
    }
    return style;
  }

  render() {
    const {
      id,
      showLabels,
      sizeButton,
      disabled,
      label,
      onClick,
      primary,
      iconName,
      mode,
      fluid,
      basic,
    } = this.props;
    const style = basic ? this.styleButtonBasic() : this.styleButton();
    const buttonView = (
      <Button
        id={id}
        onClick={onClick}
        icon
        disabled={disabled}
        style={style}
        size={sizeButton}
        onMouseEnter={this.toggleHover}
        onMouseLeave={this.toggleHover}
        primary={mode === null && primary}
        fluid={fluid}
        basic={basic}
        className={`${basic ? 'ui-button-basic' : ''}`}
      >
        <Icon name={iconName} style={basic ? style : {}} />
        {showLabels ? `  ${label}` : ''}
      </Button>
    );
    /* the basic button needs a wrapper to show the label in the defined color */
    return basic ? <div style={style}>{buttonView}</div> : buttonView;
  }
}

UiButton.propTypes = {
  id: PropTypes.string,
  showLabels: PropTypes.bool,
  sizeButton: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  onClick: PropTypes.func,
  primary: PropTypes.bool,
  iconName: PropTypes.string.isRequired,
  negative: PropTypes.bool,
  fluid: PropTypes.bool,
  basic: PropTypes.bool,
  mode: PropTypes.string,
};

UiButton.defaultProps = {
  id: 'UiButton_id',
  showLabels: true,
  sizeButton: SIZE_MEDIUM,
  disabled: false,
  label: null,
  onClick: null,
  primary: false,
  negative: false,
  fluid: false,
  basic: false,
  mode: null,
};
